export default __webpack_public_path__ + "static/media/nine_bg.d6291e09.png";